// extracted by mini-css-extract-plugin
module.exports = {"wrapper-element":"Dashboard_wrapper-element__32-eL","welcome-card":"Dashboard_welcome-card__oGy1Z","portals":"Dashboard_portals__10n3O"};